export function plusExpandIcon(isExpanded) {
    return isExpanded ? 'icon minus-box' : 'icon plus-box';
}
export function chevronExpandIcon(isExpanded) {
    return isExpanded ? 'icon chevron-down' : 'icon chevron-right';
}
